<template>
  <span v-if="canManage">
    <el-button size="small" @click="open">模型配置</el-button>
    <el-dialog title="企业模型配置" :visible.sync="visible" width="590px" append-to-body @closed="form.apiKey=''">
      <el-alert v-if="!form.encryptionReady" title="服务器尚未配置模型密钥加密主密钥，暂不能保存密钥或启用助手。" type="warning" :closable="false" />
      <el-form v-loading="loading" label-width="110px">
        <el-form-item label="启用经营助手"><el-switch v-model="form.enabled" /></el-form-item>
        <el-form-item label="模型根地址"><el-input v-model="form.endpoint" placeholder="例如 https://模型服务域名/v1" maxlength="500" /></el-form-item>
        <el-form-item label="模型名称"><el-input v-model="form.model" maxlength="128" /></el-form-item>
        <el-form-item label="API密钥"><el-input v-model="form.apiKey" type="password" autocomplete="new-password" :placeholder="form.keyConfigured?'已保存；留空保留原密钥':'首次配置请填写'" maxlength="4096" /></el-form-item>
        <p class="hint">支持带工具调用的 Chat Completions 兼容模型服务，系统在根地址后追加 /chat/completions。模型地址由本企业自行选择，可使用私有部署服务。</p>
        <p class="hint">密钥加密存储且不回显。启用后用户可选择将提问及本人权限内的CRM查询结果发送至该模型服务；写入CRM前仍需本人确认。</p>
      </el-form>
      <span slot="footer"><el-button @click="visible=false">关闭</el-button><el-button type="primary" :loading="saving" :disabled="loading || !form.encryptionReady" @click="save">保存配置</el-button></span>
    </el-dialog>
  </span>
</template>
<script>
import { crm } from '../api/crm'
export default {
  data:()=>({visible:false,loading:false,saving:false,form:{apiKey:''}}),
  computed:{canManage(){const u=this.$store.state.user || {};return ['TENANT_ADMIN','PLATFORM_ADMIN'].some(r=>u.roleCode===r || (u.roleCodes || []).includes(r))}},
  methods:{async open(){this.visible=true;this.loading=true;try{const res=await crm.aiConfig();this.form={...res.data,apiKey:''}}finally{this.loading=false}},async save(){this.saving=true;try{const res=await crm.saveAiConfig(this.form);this.form={...res.data,apiKey:''};window.dispatchEvent(new Event('crm-settings-changed'));this.$message.success('模型配置已保存')}finally{this.saving=false}}}
}
</script>
<style scoped>.hint{color:#64748b;line-height:1.7;font-size:13px}</style>
